import { createFileRoute, Outlet } from '@tanstack/react-router';

import { Footer } from './-components/footer';
import { Navbar } from './-components/navbar';

export const Route = createFileRoute('/(landing)')({
  component: LandingLayout,
});

function LandingLayout() {
  return (
    <div className="flex min-h-screen flex-col">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
